import React from 'react'

import useCategory from 'components/GamesNavBar/hooks/useCategory'
import { Icon } from 'components/IconLink/Icon'
import useProvidersWithIcons from 'utils/hooks/queries/games/useProvidersWithIcons'

import { ProviderElement, ProvidersBox } from './styles'

export function Providers() {
  const providers = useProvidersWithIcons()
  const { category, changeCategory } = useCategory()

  return (
    <ProvidersBox>
      {providers.map(({ label, slug, icon }) => (
        <ProviderElement
          key={slug}
          onClick={() => {
            changeCategory(slug)
          }}
          active={category === slug}
        >
          <span>{label}</span>
          <Icon icon={icon} />
        </ProviderElement>
      ))}
    </ProvidersBox>
  )
}
